import React, { useState, useEffect } from 'react';
import { TextField as MUITextField } from '@mui/material';
import TEXT from './text';
import { useSelector } from 'react-redux';

const NumberFieldComponent = ({ properties, value, valueUpdaterCallback, validityUpdaterCallback }) => {
    const { options = {}, constrains = {} } = properties;
    const language = useSelector(state => state.App_Settings.language);

    const [inputValue, setInputValue] = useState(value !== undefined ? value : (options.defaultValue || options.value || ''));

    // Sync with parent value changes
    useEffect(() => {
        if (value !== undefined && value !== inputValue) {
            setInputValue(value);
        }
    }, [value]);

    const handleChange = (event) => {
        const newValue = event.target.value;

        if (isNaN(newValue)) {
            return;
        }

        if (constrains.max && newValue > constrains.max) {
            return;
        }

        if (constrains.min && newValue < constrains.min) {
            return;
        }

        setInputValue(newValue);

        // Notify parent component
        if (valueUpdaterCallback) {
            valueUpdaterCallback(newValue);
        }

        // Update validity
        if (validityUpdaterCallback) {
            const isValid = options.required ? newValue.trim() !== '' : true;
            validityUpdaterCallback(isValid);
        }

        if (options.onChange) {
            options.onChange(newValue);
        }
    };

    return (
        <MUITextField
            label={options.label || TEXT.NumberField[language]}
            variant={options.variant || 'outlined'}
            value={inputValue}
            onChange={handleChange}
            placeholder={options.placeholder || ''}
            fullWidth={options.fullWidth !== false}
            required={options.required || false}
            inputProps={{
                max: constrains.max || undefined,
                min: constrains.min || undefined,
            }}
            sx={{ width: '100%', maxWidth: '100%' }}
        />
    );
};

export default NumberFieldComponent;
